import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"

import VideoCard from "./videoCard"

const CardsGallery = ({ sessionIds }) => {
  const data = useStaticQuery(graphql`
    query {
      allVideosJson {
        edges {
          node {
            id
            slug
            title
            description
            tags
            youtube {
              start
              end
            }
            speaks {
              speaker
            }
            miniature {
              childImageSharp {
                gatsbyImageData(
                  formats: [AUTO, WEBP, AVIF, PNG]
                  width: 500
                  blurredOptions: { width: 50 }
                  placeholder: BLURRED
                  transformOptions: { cropFocus: CENTER }
                  aspectRatio: 1.61
                )
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div className="max-w-6xl m-auto">
      <div className="flex flex-wrap justify-center">
        {data.allVideosJson.edges
          .filter(({ node }) => sessionIds.includes(node.id))
          .map(({ node }) => (
            <VideoCard key={node.id} {...node} />
          ))}
      </div>
    </div>
  )
}

export default CardsGallery
